// extracted by mini-css-extract-plugin
export default {"link":"BenefitCard_link__aigiL","container":"BenefitCard_container__J-HbP","logoContainer":"BenefitCard_logoContainer__AZuxM","textContainer":"BenefitCard_textContainer__DeYgd"};